import properties from './properties';

const PROPERTIES_KEY = 'real_estate_properties';

export const getProperties = () => {
  const storedProperties = localStorage.getItem(PROPERTIES_KEY);
  return storedProperties ? JSON.parse(storedProperties) : [];
};

export const saveProperties = (properties) => {
  localStorage.setItem(PROPERTIES_KEY, JSON.stringify(properties));
};

export const loadInitialProperties = () => {
  const stored = getProperties();
  if (stored.length > 0) return stored;
  
  saveProperties(properties);
  return properties;
};

export const generateNewId = () => {
  return Date.now();
};